import script from "./ProgramVersionBenchmarkList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramVersionBenchmarkList.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramVersionBenchmarkList.vue?vue&type=style&index=0&id=26c2dbde&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c2dbde"]])

export default __exports__